export default __webpack_public_path__ + "static/media/G0003.c3b93929.png";